import { gql } from "@apollo/client";

export const CREATE_SIZE = gql`
  mutation CreateSize($input: SizeInput) {
    createSize(input: $input) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const GET_SIZE_PAGINATION = gql`
  query GetSizePagination(
    $page: Int
    $limit: Int
    $pagination: Boolean
    $keyword: String
    $isUse: Boolean
  ) {
    getSizePagination(
      page: $page
      limit: $limit
      pagination: $pagination
      keyword: $keyword
      isUse: $isUse
    ) {
      data {
        _id
        sizeEnName
        sizeKhName
        isUse
        remark
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const UPADATE_SIZE_IS_USE = gql`
  mutation UpdateSizeIsUse($id: ID!, $isUse: Boolean) {
    updateSizeIsUse(_id: $id, isUse: $isUse) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const UPDATE_SIZE = gql`
  mutation UpdateSize($id: ID!, $input: SizeInput) {
    updateSize(_id: $id, input: $input) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const DELETE_SIZE = gql`
  mutation DeleteSize($id: ID!) {
    deleteSize(_id: $id) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;
